import React, { useEffect, useState } from 'react';
import { FaDownload } from 'react-icons/fa';

const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
  const handler = (e) => {
    // Prevent the mini-infobar from appearing on mobile
    e.preventDefault();
    console.log("PWA install prompt detected!"); // Debugging line
    setSupportsPWA(true);
    setPromptInstall(e);
  };

  window.addEventListener("beforeinstallprompt", handler);

  // If the app is already installed, hide the button
  window.addEventListener("appinstalled", () => {
    setSupportsPWA(false);
    setPromptInstall(null);
  });

  return () => window.removeEventListener("beforeinstallprompt", handler);
}, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) return;
    promptInstall.prompt();
  };

  if (!supportsPWA) return null;

  return (
    <button
      className="pwa-install-btn"
      onClick={onClick}
      style={{
        background: '#3b82f6',
        color: '#fff',
        padding: '10px 10px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: 'bold',
        cursor: 'pointer'
      }}
    >
      <FaDownload/> App
    </button>
  );
};

export default InstallPWA;